module.exports = __webpack_public_path__ + "static/media/minivan_pink.7e4b7f94.svg";